// ¿ESTA SESIÓN COMPRA CON PRECIO DE TÉCNICO? LO DICE EL SERVIDOR.
//
// 🔴 Por qué no lo decide la pantalla (7-sep-2026). La Tienda miraba `isTecnico(currentClaims())`
// —claims que `services/auth.js` lee SIN validar firma— y pintaba «−15% sobre lista». Desde el
// 1-sep (#340) el checkout sella el precio contra el catálogo del servidor, así que el pedido
// salía por el 100 %: medido, un carrito de $15.725.000 quedó cobrado en $18.500.000.
//
// El veredicto sale de la MISMA función que usa el checkout para sellar
// (`server/pagos/descuento-tecnico.js`), así que la pantalla no puede prometer un precio que el
// cobro no vaya a hacer. Mientras no haya sesión de técnico verificable, `aplica` es `false` y la
// Tienda simplemente no promete descuento.
import { useEffect, useState } from 'react';
import { hubGet } from './hub';
import { getToken } from './auth';

export const SIN_DESCUENTO = Object.freeze({ aplica: false, pct: 0, motivo: 'sin_respuesta' });

export function useDescuentoTecnico() {
  const [desc, setDesc] = useState(SIN_DESCUENTO);

  useEffect(() => {
    let vivo = true;
    const t = getToken();
    hubGet('tienda/descuento', {}, t ? { headers: { Authorization: `Bearer ${t}` } } : {})
      .then((r) => {
        if (!vivo || !r || r.ok === false) return;
        setDesc({
          aplica: !!r.aplica,
          pct: Number(r.pct) || 0,
          motivo: r.motivo || null,
        });
      })
      .catch(() => { /* sin veredicto no se promete nada: se queda en `aplica:false` */ });
    return () => { vivo = false; };
  }, []);

  return desc;
}
